import React from "react";
import { Modal } from "antd";
import { BANNER_SCREEN_LABELS, BANNER_TYPE, BANNER_TYPE_LABELS, SELLER_SEGMENT_LABELS } from "../../core/constants";
import { formatDateTimeRangeDisplay, formatNavigationSummary, getScreenDisplayNames } from "../../core/utils";

function BannerConfirmModal({
  visible,
  isEdit = false,
  type = BANNER_TYPE.BANNER,
  values = {},
  loading = false,
  onCancel,
  onConfirm,
}) {
  const typeLabel = BANNER_TYPE_LABELS[type] || type;
  const actionTitle = isEdit ? `Xác nhận cập nhật ${typeLabel}` : `Xác nhận tạo mới ${typeLabel}`;
  const actionPrompt = isEdit
    ? `Bạn có chắc chắn muốn cập nhật ${typeLabel} với các thông tin trên không?`
    : `Bạn có chắc chắn muốn tạo mới ${typeLabel} với các thông tin trên không?`;

  const timeDisplay = values.timeRange ? formatDateTimeRangeDisplay(values.timeRange[0], values.timeRange[1]) : "—";

  const screensDisplay = getScreenDisplayNames(values.screens || [], BANNER_SCREEN_LABELS);
  const segmentDisplay = SELLER_SEGMENT_LABELS[values.sellerSegmentType] || values.sellerSegmentType || "—";
  const navDisplay = formatNavigationSummary({
    type: values.navigationType,
    targetID: values.navigationTargetID,
    url: values.navigationURL,
    targetName: values.navigationTargetName,
  });

  const rows = [
    { label: `Tên ${typeLabel.toLowerCase()}`, value: values.name || "—" },
    { label: "Thời gian diễn ra", value: timeDisplay },
    { label: "Màn hình hiển thị", value: screensDisplay },
    { label: "Khách hàng mục tiêu", value: segmentDisplay },
    { label: "Link điều hướng", value: navDisplay },
  ];

  return (
    <Modal
      title={<div style={{ textAlign: "center", fontSize: "16px", fontWeight: 600 }}>{actionTitle}</div>}
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Xác nhận"
      cancelText="Hủy bỏ"
      confirmLoading={loading}
      width={560}
      centered
      okButtonProps={{
        style: {
          backgroundColor: "#2246dc",
          borderColor: "#2246dc",
          borderRadius: "6px",
          height: "36px",
          padding: "0 20px",
        },
      }}
      cancelButtonProps={{
        style: {
          borderRadius: "6px",
          height: "36px",
          padding: "0 20px",
        },
      }}
    >
      <div style={{ padding: "12px 8px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "16px" }}>
          <tbody>
            {rows.map((r, i) => (
              <tr
                key={r.label}
                style={{
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: i % 2 === 0 ? "#fafafa" : "#ffffff",
                }}
              >
                <td
                  style={{
                    padding: "10px 14px",
                    width: "180px",
                    color: "#595959",
                    fontSize: "13px",
                    verticalAlign: "top",
                  }}
                >
                  {r.label}
                </td>
                <td
                  style={{
                    padding: "10px 14px",
                    fontWeight: 500,
                    color: "#2246dc",
                    fontSize: "13px",
                  }}
                >
                  {r.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ textAlign: "center", color: "#595959", fontSize: "13px" }}>{actionPrompt}</div>
      </div>
    </Modal>
  );
}

export default React.memo(BannerConfirmModal);
